/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterUserDto } from '../../models/register-user-dto';

export interface BookRegisterBookRegistrationIdPost$Params {
  bookRegistrationId: string;
      body?: RegisterUserDto
}

export function bookRegisterBookRegistrationIdPost(http: HttpClient, rootUrl: string, params: BookRegisterBookRegistrationIdPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bookRegisterBookRegistrationIdPost.PATH, 'post');
  if (params) {
    rb.path('bookRegistrationId', params.bookRegistrationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as MPIStrictHttpResponse<void>;
    })
  );
}

bookRegisterBookRegistrationIdPost.PATH = '/Book/Register/{bookRegistrationId}';
